import { Controller } from '@hotwired/stimulus'

import { createApp, h } from 'vue'

import HowMuch from '@codeur/vue-how-much/src/HowMuch.vue'

import FaIcon from '@/apps/shared/components/fa-icon.vue'

import iconChrono from '@/images/how_much/icon-chrono.svg'
import iconStar from '@/images/how_much/icon-star.svg'

import './how_much_component.scss'

const reassurances = [
  {
    icon: {
      url: iconChrono,
      alt: 'Icône chronomètre'
    },
    title: 'Proposition de devis rapide',
    subtitle: '5 minutes avant votre 1<sup>er</sup> devis'
  },
  {
    icon: {
      url: iconStar,
      alt: 'Icône rubans rosette'
    },
    title: 'Déjà plus de 40 000 clients',
    subtitle: 'Noté 4,9/5 sur 600 avis'
  }
]

export default class extends Controller {
  async connect() {
    const req = await fetch('/how_much_surveys/' + (this.element.dataset.surveyId || 'app'), {
      contentType: 'application/json'
    })
    const survey = await req.json()
    const openFast = () => document.querySelector('.open-fast').click()
    window.howMuchApp = createApp({
      render() {
        return h(HowMuch, {
          survey,
          subscribePostUrl: '/how_much_subscriptions',
          ctaCallback: openFast,
          reassurances
        })
      }
    }).component('FaIcon', FaIcon)

    window.howMuchApp.mount(this.element)
  }
}
